import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Heading from '../../components/header';
import useApiLoadingOverlay from '../../hooks/useApiLoadingOverlay';
import useApiTopLoading from '../../hooks/useApiTopLoading';
import SiteContactContainer from '../../container/siteContactContainer';
import { actionNotifier } from '../../components/ui/toast';
import { useDeleteContactMutation, useGetContactListQuery } from './contactApiSlice';

const getContactRows = (payload) => {
    if (Array.isArray(payload?.rows)) {
        return payload.rows;
    }

    if (Array.isArray(payload?.data?.rows)) {
        return payload.data.rows;
    }

    if (Array.isArray(payload?.data)) {
        return payload.data;
    }

    return [];
};

const getContactCount = (payload) => {
    if (typeof payload?.count === 'number') {
        return payload.count;
    }

    if (typeof payload?.data?.count === 'number') {
        return payload.data.count;
    }

    return 0;
};

const SiteContactPage = () => {
    const dispatch = useDispatch();
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [countPerPage] = useState(10);

    const {
        data,
        isLoading,
        isFetching,
        refetch,
    } = useGetContactListQuery({
        page: currentPage,
        items: countPerPage,
        search,
    });

    const [deleteContact, { isLoading: isDeletingContact }] = useDeleteContactMutation();

    const contactList = getContactRows(data);
    const totalCount = getContactCount(data);
    const totalPages = Math.max(1, Math.ceil(totalCount / countPerPage));

    useApiTopLoading([isFetching], dispatch);
    useApiLoadingOverlay([isLoading, isDeletingContact], dispatch);

    useEffect(() => {
        setCurrentPage(1);
    }, [search]);

    useEffect(() => {
        if (currentPage > totalPages) {
            setCurrentPage(totalPages);
        }
    }, [currentPage, totalPages]);

    const onSearch = (event) => {
        setSearch(event.target.value);
    };

    const handleDeleteContact = async (id) => {
        await deleteContact(id).unwrap();
        actionNotifier.success('Contact deleted successfully.');
    };

    return (
        <>
            <Heading
                text="Contact"
                path="#"
                onSearch={onSearch}
                search={search}
                isFilterShow={false}
                isGraphShow={false}
            />
            <SiteContactContainer
                contactList={contactList}
                currentPage={currentPage}
                countPerPage={countPerPage}
                isLoading={isDeletingContact}
                onDeleteContact={handleDeleteContact}
                onPageChange={setCurrentPage}
                refetchContactList={refetch}
                totalPages={totalPages}
            />
        </>
    );
};

export default SiteContactPage;
